import { getMissingCompatibilityRequirements } from './featureCompatibilities';
export function getUninstallableReason(appInstallability, features) {
  const {
    installed,
    incompatibleHubInstalls,
    incompatibleHubUserInstalls,
    missingHubUserRoles,
    missingHubScopes,
    missingHubScopeGroups
  } = appInstallability;
  const missingCompatibilityRequirements = getMissingCompatibilityRequirements(features, appInstallability, true);
  if (installed) {
    return {
      label: 'ALREADY_INSTALLED'
    };
  }
  if (missingHubUserRoles.length && !missingHubScopes.length) {
    return {
      label: 'MISSING_USER_PERMISSIONS',
      missingHubUserRoles
    };
  }

  // If every feature requires a tier upgrade
  // e.g. requirement === (TierType || MULTIPLE_HUB_OPTIONS_AVAILABLE) -> COMPATIBILITY_NONE
  // we want to prevent users from installing the app
  // When all users have defined Feature-Editor features
  // this check can replace the missingHubScopes check
  if (missingCompatibilityRequirements.length && missingCompatibilityRequirements.every(requirement => requirement && requirement !== 'USER_CONDITIONAL_SCOPE')) {
    return {
      label: 'NO_COMPATIBLE_FEATURES'
    };
  }
  if (missingHubScopes.length || missingHubScopeGroups.length) {
    const missingScopes = missingHubScopes.length ? missingHubScopes : missingHubScopeGroups;
    return {
      label: 'MISSING_HUB_SCOPES',
      missingScopes
    };
  }
  if (incompatibleHubInstalls.length || incompatibleHubUserInstalls.length) {
    const incompatibleInstalls = incompatibleHubInstalls.length ? incompatibleHubInstalls : incompatibleHubUserInstalls;
    return {
      label: 'INCOMPATIBLE_INSTALLS',
      incompatibleInstalls
    };
  }
}